/**
 * Vervado Internal Links v2
 * - Works on all article pages (old + new)
 * - First-occurrence hub + contextual phrase links
 * - Moves Related box into article body when present in footer area
 * - Avoids ads, headings, existing links
 */
(function () {
  'use strict';
  if (window.__VERVADO_IL_V2__) return;
  window.__VERVADO_IL_V2__ = true;

  var MAX = 6;
  var path = (location.pathname || '').toLowerCase();

  var HUBS = [
    { re: /\bweekly horoscope\b/gi, href: '/blogs/horoscope', title: 'Weekly horoscope', blogs: ['horoscope'] },
    { re: /\bdaily horoscope\b/gi, href: '/blogs/horoscope', title: 'Daily horoscope', blogs: ['horoscope'] },
    { re: /\bhoroscope today\b/gi, href: '/blogs/horoscope', title: 'Horoscope today', blogs: ['horoscope'] },
    { re: /\bzodiac signs?\b/gi, href: '/blogs/horoscope', title: 'Zodiac signs', blogs: ['horoscope'] },
    { re: /\bhoroscope\b/gi, href: '/blogs/horoscope', title: 'Horoscope', blogs: ['horoscope'] },
    { re: /\bbitcoin price\b/gi, href: '/blogs/bitcoin', title: 'Bitcoin price', blogs: ['bitcoin'] },
    { re: /\bbitcoin\b/gi, href: '/blogs/bitcoin', title: 'Bitcoin', blogs: ['bitcoin'] },
    { re: /\bcryptocurrency\b/gi, href: '/blogs/bitcoin', title: 'Cryptocurrency', blogs: ['bitcoin'] },
    { re: /\bcrypto\b/gi, href: '/blogs/bitcoin', title: 'Crypto', blogs: ['bitcoin'] },
    { re: /\bvervado\b/gi, href: '/', title: 'Vervado', blogs: ['*'] }
  ];

  function onBlog(rule) {
    if (!rule.blogs || rule.blogs.indexOf('*') >= 0) return true;
    for (var i = 0; i < rule.blogs.length; i++) {
      if (path.indexOf('/blogs/' + rule.blogs[i]) >= 0) return true;
    }
    // still allow cross-hub lightly from other blogs
    return path.indexOf('/blogs/') >= 0;
  }

  function findArticleRoot() {
    var sels = [
      '.sdn-article-body', '.sdn-article .sdn-article-body',
      '.blog-post-content.rte', '.blog-post-content',
      '.article-template__content', '.article-template .rte',
      '.article__content', 'article .rte', '.rte', 'article'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el && (el.textContent || '').trim().length > 150) return el;
    }
    return null;
  }

  function skip(node) {
    var n = node;
    while (n && n !== document) {
      if (n.nodeType === 1) {
        var t = (n.tagName || '').toLowerCase();
        if ('a,h1,h2,h3,h4,h5,script,style,noscript,button,nav'.split(',').indexOf(t) >= 0) return true;
        if (n.getAttribute && n.getAttribute('data-vil') === '1') return true;
        if (n.classList && (n.classList.contains('vervado-ad-slot') || n.classList.contains('vil-box') || n.classList.contains('vervado-ad-card'))) return true;
      }
      n = n.parentNode;
    }
    return false;
  }

  function alreadyOn(href) {
    if (href === '/') return path === '/' || path === '';
    return path.indexOf(href) === 0;
  }

  function linkify(root) {
    if (!root || root.getAttribute('data-vil-v2') === '1') return 0;
    root.setAttribute('data-vil-v2', '1');
    var usedHref = {};
    var made = 0;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (var i = 0; i < nodes.length && made < MAX; i++) {
      var tn = nodes[i];
      if (!tn || !tn.nodeValue || tn.nodeValue.length < 4) continue;
      if (skip(tn.parentNode)) continue;
      var text = tn.nodeValue;

      for (var r = 0; r < HUBS.length && made < MAX; r++) {
        var rule = HUBS[r];
        if (!onBlog(rule)) continue;
        if (alreadyOn(rule.href)) continue;
        if (usedHref[rule.href]) continue;
        rule.re.lastIndex = 0;
        var m = rule.re.exec(text);
        if (!m) continue;
        // prefer mid-sentence matches longer than 3 chars
        if (!m[0] || m[0].length < 4) continue;
        var idx = m.index;
        var match = m[0];
        var before = document.createTextNode(text.slice(0, idx));
        var a = document.createElement('a');
        a.href = rule.href;
        a.textContent = match;
        a.title = rule.title;
        a.setAttribute('data-vil', '1');
        a.rel = 'noopener';
        var after = document.createTextNode(text.slice(idx + match.length));
        var parent = tn.parentNode;
        parent.insertBefore(before, tn);
        parent.insertBefore(a, tn);
        parent.insertBefore(after, tn);
        parent.removeChild(tn);
        usedHref[rule.href] = true;
        made++;
        break;
      }
    }
    return made;
  }

  function placeRelated(root) {
    var box = document.querySelector('.vil-box');
    if (!box || !root) return;
    // move related box to end of article content for UX + SEO proximity
    if (box.parentNode !== root) {
      root.appendChild(box);
    }
  }

  function init() {
    if (path.indexOf('/blogs/') === -1 && path.indexOf('/articles/') === -1) {
      // still try if article template
    }
    var root = findArticleRoot();
    if (!root) return;
    linkify(root);
    placeRelated(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // late content
  setTimeout(init, 800);
})();
